// extracted by mini-css-extract-plugin
module.exports = {"inputs":"PromptModal_inputs__7Hbyo"};